import { render, staticRenderFns } from "./TaskTypeMultiSelect.component.vue?vue&type=template&id=5c38f452&scoped=true&"
import script from "./TaskTypeMultiSelect.component.vue?vue&type=script&lang=js&"
export * from "./TaskTypeMultiSelect.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskTypeMultiSelect.component.vue?vue&type=style&index=0&id=5c38f452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c38f452",
  null
  
)

export default component.exports